import React, { useState } from "react";

import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { I18n } from "../utils/I18n";
import { EstadisticaListItem } from "../models/dataModels";


interface AccesosGraphProps {
    data: EstadisticaListItem[];
}

export const AccesosSistemaGraph = function (props: AccesosGraphProps) {

    const formatXAxis = (tickItem) => {
        return I18n.Strings.formatDate(new Date(tickItem));
    }
    const customActiveBar = (props: any) => {
        const { x, y, width, height } = props;
        return (
            <rect
                x={x}
                y={y}
                width={width}
                height={height}
                fill="rgba(0,162,163,0.5)"
                rx={1}
            />
        );
    };
    return <div className={"grafico_accesos"}>
        <ResponsiveContainer className="mt-lg" width="100%">
            <BarChart
                data={props.data}

            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="dia" tickFormatter={formatXAxis} ticks={['']} />
                <Bar dataKey="numAccesos"
                    name="Nº accesos"
                    fill="rgba(0,162,163,1)"
                    
                    activeBar={customActiveBar}
                />
                <Tooltip labelFormatter={t => I18n.Strings.formatDate(new Date(t))} />
            </BarChart>
        </ResponsiveContainer>
    </div>;
};